<template>
  <ModalDialog
    ref="dialog"
    title="Station Scan Options"
    icon="fa-scanner"
    :showFooter="true"
    :scrollable="false"
    :showSubmit="true"
    submitTitle="Select"
    :submitting="submitting"
    :submitDisabled="submitDisabled"
    @closed="onClosed"
    @submitted="onSubmitted">

    <LoadingPanel :loading="loading" :loadingError="loadingError" />
    <FormGroup v-bind:form="form" :labelColumnSize="3" v-if="!loading && !loadingError">
      <ContentTitle>Inventory Bin Options</ContentTitle>

      <FormRow label="Default Panel Inventory Bin" :suffixSlot="true">
        <FormInventoryBinSelect
          v-model="productionStation.panelInventoryBinId"
          placeholder="Panel Inventory Bin"
          :accountLocationId="productionStation.accountLocationId"
          note="Inventory bin where scanned out panels will be placed"
          field="panelInventoryBinId"
        />
        <template #suffix>
          <FormButton class="btn-default btn-block" @click="clickedScannedBin"><i class="far fa-scanner" /> Scan Bin</FormButton>
        </template>
      </FormRow>

      <FormRow label="Default Offcut Inventory Bin" v-if="isCuttingStation" :suffixSlot="true">
        <FormInventoryBinSelect
          v-model="productionStation.offcutInventoryBinId"
          placeholder="Offcut Inventory Bin"
          :accountLocationId="productionStation.accountLocationId"
          note="Inventory bin where scanned out offcuts will be placed"
          field="offcutInventoryBinId"
        />

        <template #suffix>
          <FormButton class="btn-default btn-block" @click="clickedScannedOffcutBin"><i class="far fa-scanner" /> Scan Bin</FormButton>
        </template>
      </FormRow>            
    </FormGroup>

    <Popover ref="scanBinPopover" sizeClass="popover-xlarge" :showHeader="true" headerTitle="Scan Bin Barcode"  placement="right">
      <div class="p-2">
        <FormRow label="Scan Bin Barcode">
          <FormInputText ref="popupBarcodeInput" v-model="popupBarcode" placeholder="Scan Bin Barcode" @enter="onScannedBarcode()" prependSlot>
            <template v-slot:prepend>
              <i class="far fa-scanner"></i>
            </template>
          </FormInputText>
        </FormRow>
      </div>
    </Popover>
    
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

import FormInventoryBinSelect from '@/modules/inventory/components/formInventoryBinSelect'
import Popover from '@/components/popover.vue'

import { ProductionStationTypes } from '@/store/types'

export default {
  name: 'StationScanOptionsDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
    FormInventoryBinSelect,
    Popover
  },
  props: {
    productionStationId: Number
  },
  data() {
    return {
      form: {},
      loading: false,
      loadingError: '',
      submitting: false,
      popupBarcode: '',
      popupBarcodeIsOffcutBin: false,
      productionStation: {}
    }
  },
  created() {
  },
  mounted() {
    this.requestData()
  },
  computed: {
    isCuttingStation() {
      return this.productionStation.type == ProductionStationTypes.cutting || 
        this.productionStation.type == ProductionStationTypes.cuttingOptimisation ||
        this.productionStation.type == ProductionStationTypes.cuttingBreakout
    },
    submitDisabled() {
      return this.loading || this.loadingError != ''
    }
  },
  methods: {
    show() {

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      var updateData = {
        panelInventoryBinId: this.productionStation.panelInventoryBinId,
      }
      if(this.isCuttingStation)
        updateData.offcutInventoryBinId = this.productionStation.offcutInventoryBinId

      this.form = this.clearFormResponse()
      this.submitting = true
      this.$apiService.glassProductionStationService.updateStationScanOptions(this.productionStationId, updateData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.form = this.processFormResponse(err)
      })
      .finally(() => {
        this.submitting = false
      })
    },
    requestData() {
      this.loading = true

      this.$apiService.productionService.getProductionStation(this.productionStationId)
      .then(response => {
        this.productionStation = response.data
      })
      .catch(err => {
        console.error(err)
        this.loadingError = this.processFormResponse(err).errorMessage
      })
      .finally(() => {
        this.loading = false
      })
    },
    clickedScannedBin(evt) {
      this.popupBarcode = ''
      this.popupBarcodeIsOffcutBin = false
      this.$refs.scanBinPopover.displayFromElement(evt.currentTarget)

      this.$nextTick(() => {
        this.$refs.popupBarcodeInput.focus()
      })
    },
    clickedScannedOffcutBin(evt) {
      this.popupBarcode = ''
      this.popupBarcodeIsOffcutBin = true
      this.$refs.scanBinPopover.displayFromElement(evt.currentTarget)

      this.$nextTick(() => {
        this.$refs.popupBarcodeInput.focus()
      })
    },
    onScannedBarcode() {
      this.$refs.scanBinPopover.hidePopover()

      var barcode = (this.popupBarcode + '').trim()
      this.popupBarcode = ''
      if(!barcode)
        return

      var barcodeValue = parseInt(barcode.replace(/\D/g, ''))
      if(barcodeValue <= 0 || isNaN(barcodeValue)) {
        this.warningToast('Invalid barcode scanned')
        return
      }

      if(this.popupBarcodeIsOffcutBin)
        this.productionStation.offcutInventoryBinId = barcodeValue
      else
        this.productionStation.panelInventoryBinId = barcodeValue
    }
  }
}
</script>